import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';

export function orgHasListings(org: ApiOrg) {
  const jobCount = org.jobs ? org.jobs.length : 0;
  const internshipCount = org.internships ? org.internships.length : 0;
  const volopCount = org.volops ? org.volops.length : 0;
  return jobCount > 0 || internshipCount > 0 || volopCount > 0;
}
